<script>
/* Reusable form group that displays or edit the form SELECT value */

export default {
  emits: ["save", "cancel", "input"],
  data() {
    return {
      showEdit: false,
    };
  },
  computed: {
    edit() {
      return !this.value || this.showEdit;
    },
  },
  props: {
    label: {
      required: true,
      type: String,
    },
    value: {
      type: String,
      required: false,
    },
    optionLabel: {
      type: String,
      required: false,
    },
    optionValue: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<template>
  <div v-if="!edit" class="grid grid-cols-4">
    <div class="text-left">{{ label }}</div>
    <div class="col-span-2 text-right font-bold">
      {{ value ?? "-" }}
    </div>

    <div class="ml-auto">
      <button @click="showEdit = !showEdit" class="btn-principal">
        Editar
        <fas :icon="['fas', 'edit']" />
      </button>
    </div>
  </div>
  <div v-else class="flex flex-col gap-4 sm:w-1/2">
    <div>
      <label :for="`${label}-input`">{{ label }}</label>
      <select
        :id="`${label}-input`"
        :value="value"
        @change="(e) => $emit('update', e.target.value)"
        :required="required"
      >
        <option value="0" disabled>Selecciona el {{ label }}</option>
        <option
          :key="index"
          v-for="(option, index) in options"
          :value="optionLabel ? option[optionValue] : option"
        >
          {{ optionLabel ? option[optionLabel] : option }}
        </option>
        <slot></slot>
      </select>
    </div>
    <div class="flex flex-row gap-4 ml-auto">
      <button class="btn-principal" type="button" @click="() => $emit('save')">
        Guardar
      </button>
      <button
        class="btn-secundario"
        type="button"
        @click="() => $emit('cancel')"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>
